import { useSelector, useDispatch } from 'react-redux'
import { setTheme, toggleTheme, resetThemeToSystem } from './theme.slice'

export const useDarkMode = () => {
  const dispatch = useDispatch()
  const theme = useSelector(state => state.theme.theme)

  return {
    theme,
    setMode: (mode) => dispatch(setTheme(mode)),
    toggleTheme: () => dispatch(toggleTheme()),
    resetToSystem: () => dispatch(resetThemeToSystem())
  }
}
